import React from 'react';
import Switch from '@mui/material/Switch';

export interface ToggleActiveProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ToggleActive: React.FC<ToggleActiveProps> = ({ checked, onChange }) => {
  return (
    <Switch
      color="primary"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      size="small"
    />
  );
};

export default ToggleActive;
